var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconReel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 19C7 21.2044 8.79556 23 11 23H19C21.2044 23 23 21.2044 23 19V11.8889H7V19ZM12.7778 15C12.7778 14.8444 12.8622 14.6978 12.9956 14.6178C13.1333 14.5378 13.3022 14.5333 13.44 14.6133L17.44 16.8356C17.5778 16.9111 17.6667 17.0622 17.6667 17.2222C17.6667 17.3822 17.5778 17.5333 17.44 17.6089L13.44 19.8311C13.3689 19.8711 13.2978 19.8889 13.2222 19.8889C13.1422 19.8889 13.0667 19.8667 12.9956 19.8267C12.8622 19.7467 12.7778 19.6 12.7778 19.4444V15ZM23 11C23 8.79556 21.2044 7 19 7H16.5689L19.2356 11H23ZM18.1733 11L15.5022 7H11C10.9289 7 10.8622 7 10.7956 7.00444L13.4578 11H18.1733ZM9.84444 7.17333C8.2 7.66667 7 9.19556 7 11H12.3956L9.84444 7.17333Z",
    fill: "#121111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReel);
export default __webpack_public_path__ + "static/media/icon_reel.210a112f991769cec33a237bd7d74862.svg";
export { ForwardRef as ReactComponent };